import axiosOverlay from '../../js/axiosOverlay'

const state = {
    motifs: null,
    selectedMotif: null,
    iCanWrite: [],
    iCantRead: []
};

const getters = {
    motifs: state => state.motifs,
    selectedMotif: state => state.selectedMotif,
    iCanWrite: state => state.iCanWrite,
    iCantRead: state => state.iCantRead,
    getMotifById: (state) => (motifID) => {
        return JSON.parse(state.motifs)?.find(motif => motif.id === motifID) ?? null
    },
    getMyMotif: (state, getters, rootState, rootGetters) => {
        let myMotif = []
        let allMotif = JSON.parse(state.motifs)
        if (allMotif) {
            allMotif.forEach(function(motif) {
                let flag = true
                if (motif.roleFiltresWrite != null) {
                    rootGetters['user/getRoles'].forEach(function (role) {
                        if (motif.roleFiltresWrite.includes(role)) {
                            flag = false
                        }
                    });
                }
                if (flag){
                    myMotif.push(motif)
                }
            });
        }
        return myMotif
    }
};

const mutations = {
    SET_MOTIFS(state, motifs) {
        state.motifs = motifs;
    },
    SET_SELECTED_MOTIF(state, motifID) {
        state.selectedMotif = motifID;
    },
    SET_I_CAN_WRITE(state, motifs) {
        state.iCanWrite = motifs;
    },
    SET_I_CANT_READ(state, motifs) {
        state.iCantRead = motifs;
    }
};

const actions = {
    async loadMotifsFromAPI({ commit, state, rootGetters }) {
        if (state.motifs == null) {
            let config = {
                method: 'get',
                url: process.env.VUE_APP_API_URL + "/sollicitation/motifs",
                headers: { }
            };

            try {
                const response = await axiosOverlay(config);
                let result = JSON.stringify(response.data);
                commit('SET_MOTIFS', result);

                let iCanWrite = [];
                let iCantRead = [];
                let allMotif = JSON.parse(result);
                
                allMotif.forEach(function (motif) {
                    // Remplissage de ce que je peux écrire
                    let flagWrite = true;
                    if (motif.roleFiltresWrite != null) {
                        rootGetters['user/getRoles'].forEach(function (role) {
                            if (motif.roleFiltresWrite.includes(role)){
                                flagWrite = false;
                            }
                        });
                    }
                    if (flagWrite) {
                        iCanWrite.push(motif);
                    }

                    // Remplissage de ce que je peux lire
                    let flagRead = true;
                    if (motif.roleFiltresRead != null) {
                        rootGetters['user/getRoles'].forEach(function (role) {
                            if (motif.roleFiltresRead.includes(role)){
                                flagRead = false;
                            }
                        });
                    }
                    if (!flagRead) {
                        iCantRead.push(motif);
                    }
                });
                
                commit('SET_I_CAN_WRITE', iCanWrite);
                commit('SET_I_CANT_READ', iCantRead);
                
            } catch (error) {
                console.log(error);
            }
        }
    },
    
    setSelectedMotif({ commit }, motifID) {
        commit('SET_SELECTED_MOTIF', motifID);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
